// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input, Select } from "../../../_metronic/_partials/controls";
import { states } from "../CatalogLocations/state"

// Validation schema
const CustomerEditSchema = Yup.object().shape({
  name: Yup.string()
    .min(3, "Minimum 3 symbols")
    .max(50, "Maximum 50 symbols")
    .required('Field is necesssary'),
  description: Yup.string().optional(),
  state: Yup.string().optional()

});
export function ClientEditForm({
  update,
  client,
  actionsLoading,
  handleClose,
  defaultState
}) {
  const [isSubmitting, setSubmitting] = useState(false)
  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };
  console.log(defaultState)
  return (
    <>
      <Formik
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={{
          state: defaultState,
          ...client
        }}
        validationSchema={CustomerEditSchema}
        onSubmit={(values) => {
          if (!values.state) {
            const [tmp] = Object.keys(states).sort()
            values.state = tmp
          }
          update({ ...client, ...values })

        }}
      >
        {({ handleSubmit, handleChange, errors, values }) => (
          <>
            <Modal.Body className="  cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  {/* Last Name */}
                  <div className="col-lg-4">
                    <Field
                      name="name"
                      component={Input}
                      placeholder="Region Name"
                      label="Region Name"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>

                  <div className="col-lg-8">
                    <Field
                      name="description"
                      component={Input}
                      placeholder="Description"
                      label="Description"
                      onInput={toInputUppercase}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-lg-4">
                    <Select name="state" label="State" >

                      {Object.keys(states)
                        .sort()
                        .map((state, key) => (
                          <option key={key} value={state}>
                            {state}
                          </option>
                        ))}
                    </Select>
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={handleClose}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                onClick={() => {

                  setSubmitting(true)
                  handleSubmit()
                  setTimeout(() => setSubmitting(false), 500)
                }}
                disabled={isSubmitting}
                className="btn btn-primary btn-elevate"
              >
                {isSubmitting ?
                  <div className="d-flex align-items-center">
                    <div className="mr-2">Loading...</div>
                    <div className="spinner spinner-white mr-10"></div>
                  </div> : "Save"}
              </button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}

export function ClientEditModal(props) {
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.handleClose}
        size="lg"
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>{props.client.uid ? "Edit Region" : "New Region"}</h1>
        </Modal.Header>

        <ClientEditForm {...props} />
      </Modal>
    </>
  );
}
export function ClienDeleteModal(props) {
  return (
    <>
      <Modal
        show={props.delete}
        onHide={props.hideDelete}
        size="lg"
        dialogClassName="p-5"
      >
        <Modal.Header>
          <h1>Delete Region</h1>
        </Modal.Header>
        <Modal.Body>
          Are you sure to permanently delete this <b>Region</b>?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            onClick={props.hideDelete}
            className="btn btn-light btn-elevate"
          >
            Cancel
          </button>
          <> </>
          <button
            type="submit"
            onClick={() => props.deleteClient(props.client.uid)}
            className="btn btn-danger btn-elevate"
          >
            Delete
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
